import type { StockStatus } from '~/domain/stockStatus';

import type { CapiProductPage, ProductStockListings } from './capi/pdp';
import type {
  Image,
  Price,
  ProductListItem,
  ProductSubType
} from './capi/shared';
import type {
  CapiSoleMarketSelection,
  Listing
} from './capi/soleMarketSellerSelection';

export type TrackableProduct = {
  brand?: string; // temp optional
  genders?: string[]; // temp optional
  image?: Image; // temp optional
  legacy_id?: string; // temp optional
  model?: string; // temp optional
  name: string;
  path?: string;
  price: Price;
  product_id?: number; // temp optional
  queryID?: string;
  stock_listings?: ProductStockListings;
  stock_status?: StockStatus; // temp optional
  style_code?: string; // temp optional
  sub_brand?: string;
  sub_type?: ProductSubType; // temp optional
};

export function fromProductListItem(
  listItem: ProductListItem
): TrackableProduct {
  return {
    ...listItem,
    product_id: listItem.id
  };
}

export function fromProductDetailPage(page: CapiProductPage): TrackableProduct {
  return {
    ...page,
    image: page.gallery[0],
    sub_brand: page._event_data.gtm.productSubBrand
  };
}

export function fromSoleMarketSelectionPage(
  page: CapiSoleMarketSelection,
  listing: Listing
): TrackableProduct {
  return {
    brand: page.brand,
    genders: page.genders,
    image: page.product_image,
    legacy_id: page.legacy_id,
    model: page.model,
    name: page.product_name,
    price: {
      currency: 'GBP',
      regular: parseFloat(listing.total_price)
    },
    product_id: page.product_id,
    stock_status: page.stock_status,
    style_code: page.style_code,
    sub_type: 'sneaker'
  };
}
